export enum Shield {
  None,
  Fighter,
  Magic,
  Mirror
}
